import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from './auth.service';
import { ToastService } from './toast.service';

export const adminGuard: CanActivateFn = () => {
  const auth = inject(AuthService);
  const router = inject(Router);
  const toast = inject(ToastService);

  const user = auth.currentUser();

  // Not logged in at all → go to login
  if (!user) {
    toast.push('Please sign in to continue.', 'error');
    return router.parseUrl('/login');
  }

  // Logged in but not admin → go home
  // Use Number() to safely handle both string "1" and number 1 from localStorage/API
  if (Number(user.UsrRole) === 1) {
    return true;
  }

  toast.push('Admin access only.', 'error');
  return router.parseUrl('/home');
};
